export const safeJsonParse = <T>(jsonString: string, fallback?: T) => {
  try {
    return JSON.parse(jsonString) as T;
  } catch (e) {
    return fallback;
  }
};
